module.exports = __webpack_public_path__ + "static/img/CARD1.ccbb5fed.png";